import {
  format,
  addSeconds,
  differenceInMilliseconds,
} from 'date-fns'

function getMountElement(mountSelector?: HTMLElement | string | null) {
  if (mountSelector instanceof HTMLElement) {
    return mountSelector
  }

  return mountSelector
    ? document.querySelector(mountSelector)
    : null
}

export function useExpireTime({
  offsetSeconds,
  timeFormat = 'mm:ss',
  mountSelector,
  afterCountdown,
}: {
  offsetSeconds: number
  timeFormat?: string
  mountSelector?: HTMLElement | string
  afterCountdown?: () => void
}) {
  const mountElement = getMountElement(mountSelector)
  const endDate = addSeconds(new Date(), offsetSeconds)
  let timeoutId: number

  function stopTimer() {
    clearInterval(timeoutId)
    afterCountdown?.()
  }

  function updateTimer() {
    const timeLeft = differenceInMilliseconds(endDate, new Date())

    if (timeLeft <= 0) {
      stopTimer()
      return
    }

    if (mountElement) {
      mountElement.textContent = format(timeLeft, timeFormat)
    }
  }

  timeoutId = window.setInterval(updateTimer, 1000)
  updateTimer()

  return {
    stopTimer,
  }
}
